import { getString } from "../common/common";

export const LGN = "LGN";
export const SOR = "SOR";
export const VYR = "VYR";
export const EML_ID = "EML_ID";
export const FL_NAME = "FL_NAME";
export const CNTRY_CODE = "CNTRY_CODE";
export const MB_NO = "MB_NO";
export const PWD = "PWD";
export const SET_PWD = "SET_PWD";
export const PWD_LNG_ERR = "PWD_LNG_ERR";
export const RE_CNFRM_PWD_LNG_ERR = "RE_CNFRM_PWD_LNG_ERR";
export const FG_PWD = "FG_PWD";
export const RE_CNFRM_PWD = "RE_CNFRM_PWD";
export const CHNG_PWD = "CHNG_PWD";
export const UR_IP = "UR_IP";
export const NO_ACC_ERR = "NO_ACC_ERR";

export const VAL_EML_ID_REQ = "VAL_EML_ID_REQ";
export const VAL_FL_NAME = "VAL_FL_NAME";
export const VAL_EML_N_MOB = "VAL_EML_N_MOB";
export const VAL_PHN_NO = "VLD_PHN_NO";

export const PLZ_ENT_EML = "PLZ_ENT_EML";
export const PLZ_ENT_PH = "PLZ_ENT_PH";
export const PLZ_ENT_PWD = "PLZ_ENT_PWD";
export const PLZ_ENT_SAME_PWD = "PLZ_ENT_SAME_PWD";
export const PLZ_ENT_RE_CNFRM_PWD = "PLZ_ENT_RE_CNFRM_PWD";
export const PLZ_ENT_NM = "PLZ_ENT_NM";
export const PLZ_ENT_OTP = "PLZ_ENT_OTP";

export const ENT_OTP = "ENT_OTP";
export const ENT_CC = "ENT_CC";
export const ENT_NEW_PWD = "ENT_NEW_PWD";

export const AGREE_TXT = "AGREE_TXT";
export const TNC = "TNC";
export const AND = "AND";
export const PRIVACY = "PRIVACY";
export const AGREE_END = "AGREE_END";

export const U_NEED_TO_AGREE = "U_NEED_TO_AGREE";

export const AGREE = "AGREE";
export const DONT_AGREE = "DONT_AGREE";


export const CMPLT_ACC_REG = "CMPLT_ACC_REG";
export const OTP_RCV_TXT = "OTP_RCV_TXT";
export const OTP_RSND_IN = "OTP_RSND_IN";
export const OTP_SEND_NOW = "OTP_SEND_NOW";
export const WRONG_OTP = "WRONG_OTP";

export const ACC_CRETN_SUCSS = "ACC_CRETN_SUCSS";
export const PWD_CHNGD_SUCSS = "PWD_CHNGD_SUCSS";
export const PWD_NT_MATCH = "PWD_NT_MATCH";

export const translations = {
    en: {
        [LGN]: "Login",
        [SOR]: "Signup / Registration",
        [VYR]: "Validate Your Registration",
        [EML_ID]: "Email ID",
        [FL_NAME]: "Full Name",
        [CNTRY_CODE]: "Country code",
        [MB_NO]: "Mobile Number",
        [PWD]: "Password",
        [SET_PWD]: "Set Password",
        [PWD_LNG_ERR]: "Password must be at least 6 characters long.",
        [RE_CNFRM_PWD_LNG_ERR]: "Reconfirm Password must be at least 6 characters long.",
        [ENT_NEW_PWD]: "Enter New Password",
        [ENT_NEW_PWD]: "Please Enter the  same Password",
        [RE_CNFRM_PWD]: "Reconfirm Password",
        [FG_PWD]: "Forgot Password?",
        [CHNG_PWD]: "CHANGE PASSWORD",
        [PWD_NT_MATCH]: "Entered passwords do not match.",

        [VAL_EML_N_MOB]: "VALIDATE EMAIL& MOBILE NUMBER",
        [VAL_FL_NAME]: "Valid Full Name",
        [VAL_EML_ID_REQ]: "Valid Email Id Required",
        [VAL_PHN_NO]: "Valid Phone Number",

        [PLZ_ENT_EML]: "Please Enter Email",
        [PLZ_ENT_PH]: "Please Enter Phone",
        [PLZ_ENT_PWD]: "Please Enter Password",
        [PLZ_ENT_RE_CNFRM_PWD]: "Please Enter Reconfirm Password",
        [PLZ_ENT_NM]: "Please Enter Name",
        [PLZ_ENT_OTP]: "Please Enter OTP",

        [ENT_OTP]: "Enter OTP (One Time Password)",
        [ENT_CC]: "Enter Country Code",


        [UR_IP]: "Your IP Address",
        [NO_ACC_ERR]: "There is no accounts exist's with given user name",
        [AGREE_TXT]: `By providing these details, you agree to our  `,
        [TNC]: "Terms & Conditions",
        [AND]: ` and `,
        [PRIVACY]: "Privacy Policy",
        [AGREE_END]: "",

        [U_NEED_TO_AGREE]: "You need to agree to KSRTC's",
        [AGREE]: "AGREE",
        [DONT_AGREE]: "DON'T AGREE",

        [CMPLT_ACC_REG]: "COMPLETE ACCOUNT REGISTRATION",
        [OTP_RCV_TXT]: "You shall receive OTP on your Email ID/ Mobile Number in next 5 min. valid for next 5 min.",
        [OTP_RSND_IN]: "You can resend the OTP in",
        [OTP_SEND_NOW]: "You can resend the OTP now",
        [WRONG_OTP]: "You’ve entered wrong OTP",

        [ACC_CRETN_SUCSS]: "Account Created Succesfully Please log in",
        [PWD_CHNGD_SUCSS]: "Password changed Succesfully. Please log in",
        [PLZ_ENT_SAME_PWD]:"Entered passwords do not match.",
    },
    kn: {
        [LGN]: "ಲಾಗ್‍ಇನ್",
        [SOR]: "ಸೈನ್ ಅಪ್ / ನೋಂದಣಿ",
        [VYR]: "ನಿಮ್ಮ ನೋಂದಣಿಯನ್ನು ಮೌಲ್ಯೀಕರಿಸಿ",
        [EML_ID]: "ಇಮೇಲ್ ಐಡಿ",
        [FL_NAME]: "ಪೂರ್ತಿ ಹೆಸರು",
        [CNTRY_CODE]: "ದೇಶದ ಕೋಡ್",
        [MB_NO]: "ಮೊಬೈಲ್ ಸಂಖ್ಯೆ.",
        [PWD]: "ಗುಪ್ತಪದ",
        [SET_PWD]: "ಗುಪ್ತಪದ ಸೆಟ್ ಮಾಡಿ",
        [PWD_LNG_ERR]: "ಗುಪ್ತಪದ ಕನಿಷ್ಠ 6 ಅಕ್ಷರಗಳ ಉದ್ದವಿರಬೇಕು ಎಂದು ಮರುದೃಢೀಕರಿಸಿ.",
        [RE_CNFRM_PWD_LNG_ERR]: "ಗುಪ್ತಪದ ಕನಿಷ್ಠ 6 ಅಕ್ಷರಗಳ ಉದ್ದವಿರಬೇಕು ಎಂದು ಮರುದೃಢೀಕರಿಸಿ.",
        [ENT_NEW_PWD]: "ಹೊಸ ಗುಪ್ತಪದ ಎಂಟರ್ ಮಾಡಿ",
        [ENT_NEW_PWD]: "ದಯವಿಟ್ಟು ಅದೇ ಗುಪ್ತಪದ ಅನ್ನು ಎಂಟರ್ ಮಾಡಿ",
        [RE_CNFRM_PWD]: "ಪಾಸ್ವರ್ಡ್ ಅನ್ನು ಮತ್ತೆ ದೃಢೀಕರಿಸಿ",
        [FG_PWD]: "ಗುಪ್ತಪದ ಮರೆತಿರಾ?",
        [CHNG_PWD]: "ಗುಪ್ತಪದ ಬದಲಿಸಿ",
        [PWD_NT_MATCH]: "ಎಂಟರ್ ಮಾಡಿದ ಪಾಸ್‌ವರ್ಡ್‌ಗಳು ಹೊಂದಿಕೆಯಾಗುತ್ತಿಲ್ಲ.",

        [VAL_EML_N_MOB]: "ಇಮೇಲ್ ಮತ್ತು ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯನ್ನು ಮೌಲ್ಯೀಕರಿಸಿ",
        [VAL_EML_ID_REQ]: "ಸರಿಯಾದ ಇಮೇಲ್ ಬೇಕಿದೆ ",
        [VAL_FL_NAME]: "ಸರಿಯಾದ ಪೂರ್ತಿ ಹೆಸರು",
        [VAL_PHN_NO]: "ಮಾನ್ಯವಾದ ಫೋನ್ ನಂಬರ್",

        [PLZ_ENT_EML]: "ದಯವಿಟ್ಟು ಇಮೇಲ್ ಐಡಿ ಎಂಟರ್ ಮಾಡಿ",
        [PLZ_ENT_PH]: "ದಯವಿಟ್ಟು ಮೊಬೈಲ್ ನಂಬರ್ ಎಂಟರ್ ಮಾಡಿ",
        [PLZ_ENT_PWD]: "ದಯವಿಟ್ಟು ಗುಪ್ತಪದ ಎಂಟರ್ ಮಾಡಿ",
        [PLZ_ENT_RE_CNFRM_PWD]: "ದಯವಿಟ್ಟು ಗುಪ್ತಪದ ಮರುದೃಢೀಕರಿಸಿ ಎಂಟರ್ ಮಾಡಿ",
        [PLZ_ENT_NM]: "ದಯವಿಟ್ಟು ಹೆಸರು ಎಂಟರ್ ಮಾಡಿ",
        [PLZ_ENT_OTP]: "ದಯವಿಟ್ಟು OTP ಎಂಟರ್ ಮಾಡಿ",

        [ENT_OTP]: "OTP(ಒನ್ ಟೈಮ್ ಗುಪ್ತಪದ) ಎಂಟರ್ ಮಾಡಿ",
        [ENT_CC]: "ದೇಶದ ಕೋಡ್ ಎಂಟರ್ ಮಾಡಿ",


        [UR_IP]: "ನಿಮ್ಮ IP ವಿಳಾಸ",
        [NO_ACC_ERR]: "ನೀಡಿದ ಬಳಕೆದಾರ ಹೆಸರಿನೊಂದಿಗೆ ಯಾವುದೇ ಅಕೌಂಟ್ ಅಸ್ತಿತ್ವದಲ್ಲಿಲ್ಲ",
        [AGREE_TXT]: `ಈ ವಿವರಗಳನ್ನು ನೀಡುವ ಮೂಲಕ, ನೀವು ನಮ್ಮ  `,
        [TNC]: "ನಿಯಮಗಳು ಮತ್ತು ನಿಬಂಧನೆಗಳು",
        [AND]: ` ಮತ್ತು  `,
        [PRIVACY]: "ಗೌಪ್ಯತೆ ನೀತಿಯನ್ನು",
        [AGREE_END]: " ಒಪ್ಪುತ್ತೀರಿ",

        [U_NEED_TO_AGREE]: "ನೀವು KSRTCಗೆ ಒಪ್ಪಿಗೆ ನೀಡಬೇಕು",
        [AGREE]: "ಒಪ್ಪುತ್ತೇನೆ",
        [DONT_AGREE]: "ಒಪ್ಪುವುದಿಲ್ಲ",

        [CMPLT_ACC_REG]: "ಅಕೌಂಟ್ ರಿಜಿಸ್ಟ್ರೇಷನ್ ಪೂರ್ಣಗೊಳಿಸಿ",
        [OTP_RCV_TXT]: "ಮುಂದಿನ 5 ನಿಮಿಷಗಳಲ್ಲಿ ನಿಮ್ಮ ಇಮೇಲ್ ಐಡಿ/ಮೊಬೈಲ್ ನಂಬರ್ ಗೆ ನೀವು OTP ಅನ್ನು ಪಡೆಯುತ್ತೀರಿ. ಮುಂದಿನ 5 ನಿಮಿಷಕ್ಕೆ ಮಾನ್ಯವಾಗಿರುತ್ತದೆ.",
        [OTP_RSND_IN]: "ನೀವು OTP ಅನ್ನು ಇಷ್ಟರೊಳಗೆ ಮತ್ತೆ ಕಳುಹಿಸಬಹುದು",
        [OTP_SEND_NOW]: "ನೀವು ಈಗ OTPಯನ್ನು ಮತ್ತೆ ಕಳುಹಿಸಬಹುದು",
        [WRONG_OTP]: "ನೀವು ತಪ್ಪಾದ OTP ಅನ್ನು ಎಂಟರ್ ಮಾಡಿರುವಿರಿ",

        [ACC_CRETN_SUCSS]: "ಅಕೌಂಟ್ ಅನ್ನು ಯಶಸ್ವಿಯಾಗಿ ರಚಿಸಲಾಗಿದೆ ದಯವಿಟ್ಟು ಲಾಗ್ ಇನ್ ಮಾಡಿ",
        [PWD_CHNGD_SUCSS]: "ಗುಪ್ತಪದ ಯಶಸ್ವಿಯಾಗಿ ಬದಲಾಯಿಸಲಾಗಿದೆ. ದಯವಿಟ್ಟು ಲಾಗಿನ್ ಆಗಿ",
        [PLZ_ENT_SAME_PWD]:"ಎಂಟರ್ ಮಾಡಿದ ಪಾಸ್‌ವರ್ಡ್‌ಗಳು ಹೊಂದಿಕೆಯಾಗುತ್ತಿಲ್ಲ.",
    },
};

export const t = (key = "") => {
    return getString(key, translations)
}